module.exports = __webpack_public_path__ + "static/img/ningmeng.3569f610.svg";